
    import {PageRequest} from '@/store/shared/entity'
    import CreateUser from './component/create-user.vue'
    import EditUser from './component/edit-user.vue'
    import ResetPassword from './component/reset-password.vue'
    import { Component, Mixins, ActionButtonConfig, PageResultBaseMixins, PageResultModalMixins } from "@/lib";

    class  PageUserRequest extends PageRequest{
        name:string;
        userName:string;
    }

    @Component({
        name: "user",
        components:{CreateUser,EditUser,ResetPassword}
    })
    export default class Users extends  Mixins(PageResultBaseMixins,PageResultModalMixins){
        buttons = { ...this.addBtn() };

        data:any = {
            model: new PageUserRequest(),
            queryAction:"system/user/getAll",
            isAutoQuery: true,
            cols:this.columns
        }

        get columns(){
            return [
                { title:this.L('app.User.UserName'), key:'userName', align: 'center',width: 180},
                { title:this.L('app.User.Name'), key:'name', align: 'center',width: 180},
                this.$util.render.baseColumn("app.User.BusinessGroup", null, {key: "businessGroup", align: 'center', render: (h: any, params: any) => {
                    return [h("span", 
                    this.getCodeDescription(this.$appconst.codeCategory.businessGroup,params.row.businessGroup)
                    )];
                }}),
                { title:this.L('app.User.EmailAddress'), key:'email', align: 'center'},
                // { 
                //     title:this.L('Users.IsActive'),
                //     render:(h:any,params:any)=>{
                //         return h('span',params.row.isActive?this.L('Action.Yes'):this.L('Action.No'))
                //     }, align: 'center',width: 100
                // },
                // this.$util.render.dateColumn("Field.CreationTime", "creationTime", { align: 'center', width: 150}),
                this.$util.render.actions(this.colButtons, ()=>{return {fixed: "right"}})
            ]
        }

        colButtonCheck = (row) => {
            return row.userName !== "admin";
        }

        get colButtons():ActionButtonConfig[]{ 
            return [
                this.colEditBtnM(row => this.colButtonCheck(row)),
                this.colDeleteBtn( row => this.colButtonCheck(row)),
                this.colCommonBtnM("Users.ResetPassword",'Pages.Users.ResetPassword','','reset-password-modal',
                row => {
                    this.$store.commit(
                        "system/user/setResetPassword",
                        {userId: row.id, userName: row.userName, name: row.name}
                    )
                }, null),
            ]
        }

        async created(){
            await this.$store.dispatch({
                type:'system/user/getRoles'
            })
        }

        reset(){
            this.data.model = new PageUserRequest();
        }
    }
